import { useAtom } from 'jotai';

import { Stack } from '@crossnokaye/ux-common';

import { DeviceAttributeCheckboxList } from '@/features/trends/components/selections-sidebar/components/device-attributes/device-attribute-list';
import {
  SelectionsDeviceGroup,
  SidebarAccordionItem,
} from '@/features/trends/components/selections-sidebar/selections.types';
import { SelectionsDevice } from '@/features/trends/components/selections-sidebar/selections.types';
import SelectionsState from '@/features/trends/components/selections-sidebar/state/selections.state';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/ux-common/components/accordion/accordion';
import { Badge } from '@/ux-common/components/badge/badge';
import { Header, HeaderTitle } from '@/ux-common/components/header/header';
import { Typography } from '@/ux-common/components/typography/typography';

type SelectionsListGroupingProps = {
  item: SidebarAccordionItem<SelectionsDeviceGroup>;
};

export const SelectionsListGrouping = ({ item }: SelectionsListGroupingProps) => {
  const [expandedSectionIds, setExpandedSectionIds] = useAtom(SelectionsState.expandedSectionIds);

  return (
    <Stack className="pl-4">
      <Accordion type={'multiple'} value={expandedSectionIds} onValueChange={setExpandedSectionIds}>
        {item?.data?.devices.map((item: SidebarAccordionItem<SelectionsDevice>) => (
          <AccordionItem key={item.value} value={item.value}>
            <AccordionTrigger>
              <Header>
                <HeaderTitle>
                  <Typography as="span" className="text-nav-header">
                    {item.title}
                  </Typography>
                  <Badge className="badge-tier2 badge-xs">{item.data?.displayRefs?.length}</Badge>
                </HeaderTitle>
              </Header>
            </AccordionTrigger>
            <AccordionContent>
              <DeviceAttributeCheckboxList item={item} />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Stack>
  );
};
